module.exports = {"1":"Dårlig","2":"Mangelfull","3":"Middels","4":"Veldig bra","5":"Glimrende","1.5":"Dårlig","2.5":"Mangelfull","3.5":"Middels","4.5":"Glimrende"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/resources/localization/nb-NO/star-ratings.json
// module id = 1317
// module chunks = 0